import { CSSProperties, FC } from 'react';
import TableGroup from './TableGroup';
import { TableGroup as TableGroupType } from 'types/common';
import 'assets/app.scss';

interface SeatLayoutProps {
    tableGroups: TableGroupType[];
    booked: string[];
    booking: string;
    toggle: (location: string) => void;
    blockedLocations?: string[];
    disabledLocations?: string[];
    allowSelectOccupied?: boolean;
}

const SeatLayout: FC<SeatLayoutProps> = ({
    tableGroups,
    booked,
    booking,
    toggle,
    blockedLocations = [],
    disabledLocations = [],
    allowSelectOccupied = false
}) => {
    return (
        <div className="table-clearfix table-scroller">
            <div className="table-layout">
                <div className="table-group-area" style={{ float: 'left', top: '520px', left: '140px' }}>
                    {tableGroups.map(group => (
                        <TableGroup
                            key={group.name}
                            name={group.name}
                            booked={booked}
                            booking={booking}
                            toggle={toggle}
                            blockedLocations={blockedLocations}
                            disabledLocations={disabledLocations}
                            allowSelectOccupied={allowSelectOccupied}
                            groupSize={group.groupSize}
                            groupType={group.groupType}
                            startOffset={group.startOffset}
                            rotate={group.rotate}
                            style={group.style as CSSProperties}
                        />
                    ))}
                </div>
                <div className="table-food-table">Ruokapöytä</div>
            </div>
        </div>
    );
};

export default SeatLayout;
